import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { setCaptionsFlag, setPauseFlag } from '../../../../actions/jre';

// analytics-track-start: helper for player button analytics
const postAnalyticsMessage = (eventName, props = {}) => {
    if (window.parent && window.parent !== window) {
        window.parent.postMessage(
            {
                type: 'analytics',
                event: eventName,
                props
            },
            '*'
        );
    }
};
// analytics-track-end

class AppPlayerComponent extends React.Component {

    constructor(props) {
        super(props);
        this.selectPage = this.selectPage.bind(this);
        this.audioPlay = this.audioPlay.bind(this);
        this.audioEnded = this.audioEnded.bind(this);
        this.audioPause = this.audioPause.bind(this);
        this.videoPlay = this.videoPlay.bind(this);
        this.videoPause = this.videoPause.bind(this);
        this.assessmentStart = this.assessmentStart.bind(this);
        this.assessmentFinish = this.assessmentFinish.bind(this);
        this.toggle = this.toggle.bind(this);
        this.toggleCaption = this.toggleCaption.bind(this);
        this.handlePreviousClick = this.handlePreviousClick.bind(this);
        this.handleReplayClick = this.handleReplayClick.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
        this.handleToggleClick = this.handleToggleClick.bind(this);
        this.handleCaptionClick = this.handleCaptionClick.bind(this);
        this.state = {
            captionsDisabled: false,
            visible: false,
            pause: null,
            isDisabled: true,
            prevDisabled: true,
            nextDisabled: true,
            isLoading: false,
            delayingNext: false,
        };
    }

    UNSAFE_componentWillMount() {
        const { users } = this.props;
        this.props.setCaptionsFlag(false, users);
    }

    toggleCaption(users) {
        const visible = !this.state.visible;
        if (visible) {
            this.props.setCaptionsFlag(true, users);
        } else {
            this.props.setCaptionsFlag(false, users);
        }
        this.setState({ visible: visible });
    }

    componentDidMount() {
        document.addEventListener('jre-select-page', this.selectPage);
        document.addEventListener('jre-audio-play', this.audioPlay);
        document.addEventListener('jre-audio-pause', this.audioPause);
        document.addEventListener('jre-audio-ended', this.audioEnded);
        document.addEventListener('jre-video-play', this.videoPlay);
        document.addEventListener('jre-video-pause', this.videoPause);
        document.addEventListener('jre-video-ended', this.audioEnded);
        document.addEventListener('jre-assessment-start', this.assessmentStart);
        document.addEventListener('jre-assessment-finish', this.assessmentFinish);
        const { users } = this.props;
        // console.log(users);
        // users.map(user => {
        //
        // });
    }

    componentWillUnmount() {
        document.removeEventListener('jre-select-page', this.selectPage);
        document.removeEventListener('jre-audio-play', this.audioPlay);
        document.removeEventListener('jre-audio-pause', this.audioPause);
        document.removeEventListener('jre-audio-ended', this.audioEnded);
        document.removeEventListener('jre-video-play', this.videoPlay);
        document.removeEventListener('jre-video-pause', this.videoPause);
        document.removeEventListener('jre-video-ended', this.audioEnded);
        document.removeEventListener('jre-assessment-start', this.assessmentStart);
        document.removeEventListener('jre-assessment-finish', this.assessmentFinish);

        if (this._reqDelayTimer) {
            clearTimeout(this._reqDelayTimer);
            this._reqDelayTimer = null;
        }
    }

    componentDidUpdate(prevProps) {
        // console.log(prevProps);
        // console.log(prevProps.requiredNodeNotCompleted);
        // when requiredNodeNotCompleted changes true -> false
        if (prevProps.requiredNodeNotCompleted && !this.props.requiredNodeNotCompleted) {

            // hold a 2s delay window that overrides the button
            if (this._reqDelayTimer) clearTimeout(this._reqDelayTimer);
            this.setState({ delayingNext: true });
            this._reqDelayTimer = setTimeout(() => {
                this.setState({ delayingNext: false });
                this._reqDelayTimer = null;
            }, 3500);
        }
    }

    //disable caption button during assessment
    assessmentStart() {
        this.setState({
            captionsDisabled: true,
            visible: false, //visible is false so that caption button won't appear as 'on' whilst faded
            showbuttons: false//joyson
        });
    }

    //enable caption button when not in assessment
    assessmentFinish() {
        this.setState({
            captionsDisabled: false,
            showbuttons: true//joyson
        });
    }

    audioPlay() {
        this.setState({
            pause: false,
            isDisabled: false,
            nextDisabled: true,
            showbuttons: true,
            isLoading: false,
        });
    }

    audioPause() {
        this.setState({
            pause: true,
            isDisabled: false,
        });
    }

    // audioEnded is also used for videos
    audioEnded() {
        this.setState({
            isDisabled: true,
            pause: null,
            nextDisabled: false,
            isLoading: false,
        });
    }

    videoPlay() {
        //this.props.setPauseFlag(false); // this is necessary to ensure playing video sets the global toggle as well
        this.setState({
            pause: false,
            isDisabled: false,
            nextDisabled: true,
            isLoading: false,
        });
    }

    videoPause() {
        //this.props.setPauseFlag(true); // this is necessary to ensure pausing video sets the global toggle as well
        this.setState({
            pause: true,
            isDisabled: false,
        });
    }

    /*selectPage() {
        this.props.setPauseFlag(null);
        this.setState({
            pause: null,
            isDisabled: true,
            nextDisabled: false
        });
    }*/

    selectPage() {
        const { users } = this.props;

        if (this.props.pauseFlag == null) {
            this.setState({
                pause: null,
                isDisabled: true,
                nextDisabled: false,
                showbuttons: true//joyson
            });
        } else {
            this.props.setPauseFlag(null, users);
        }
    }




    handlePreviousClick() {
        postAnalyticsMessage('iframe_element_clicked', {
            element: 'prev-button',
            text: 'Previous Page',
            page: window.location.pathname
        });
        this.props.previousPage();
    }

    handleReplayClick() {
        postAnalyticsMessage('iframe_element_clicked', {
            element: 'replay-button',
            text: 'Replay Slide',
            page: window.location.pathname
        });
        this.setState({ isLoading: true, nextDisabled: true });
        this.props.refreshSlide();
    }

    handleNextClick() {
        postAnalyticsMessage('iframe_element_clicked', {
            element: 'next-button',
            text: 'Next Page',
            page: window.location.pathname
        });
        this.props.nextPage();
    }

    handleToggleClick() {
        const { pause = false } = this.state;
        postAnalyticsMessage('iframe_element_clicked', {
            element: 'play-pause-button',
            text: pause ? 'Play' : 'Pause',
            page: window.location.pathname
        });
        this.toggle(this.props.users);
    }

    handleCaptionClick(users) {
        postAnalyticsMessage('iframe_element_clicked', {
            element: 'captions-button',
            text: 'Toggle Captions',
            page: window.location.pathname
        });
        this.toggleCaption(users);
    }

    toggle(users) {
        const { pause = false } = this.state;
        if (pause === true) {
            this.props.setPauseFlag(false, users);
        } else if (pause === false) {
            this.props.setPauseFlag(true, users);
        }
    }

    render() {
        const { submitting, takingAssessment, preventMultiClick, requiredNodeNotCompleted } = this.props;
        const { pause = false, isDisabled = true,
            prevDisabled = true, latestPage, nextDisabled = false, captionsDisabled, showbuttons = true
        } = this.state;
        const ccStyle = classnames('plbtn-cc', {
            active: this.state.visible
        });
        const toggleClass = (pause) ? 'plbtn-play' : 'plbtn-pause';
        const { nextBtnDisabled, prevBtnDisabled, users } = this.props;
        // console.log(nextBtnDisabled);
        return (
            <div className="playerbuttons">
                <div className="jre-student-name pull-left">
                    {`${users[0].firstName} ${users[0].lastName}`}
                </div>
                {showbuttons &&
                    <div className="pl-buttoninner">
                        <button name="prevButton" className="plbtn-prev" onClick={this.handlePreviousClick}
                            disabled={prevBtnDisabled} />
                        <button className="plbtn-replay" onClick={this.handleReplayClick} disabled={submitting
                            || takingAssessment} />
                        <button className={toggleClass} onClick={this.handleToggleClick} disabled={isDisabled || submitting
                            || takingAssessment} />
                        <button className={ccStyle} disabled={isDisabled || submitting
                            || takingAssessment} type="button" onClick={() => this.handleCaptionClick(users)} />
                        {/* TODO: Remove student if not equal */}
                        <button name="nextButton" className="plbtn-next" onClick={this.handleNextClick} id="nextbutton"
                            disabled={nextBtnDisabled || (this.props.role === 'student' && nextDisabled) || submitting || this.state.isLoading || takingAssessment || preventMultiClick || requiredNodeNotCompleted || this.state.delayingNext} />
                    </div>
                }
                {users.length > 1 &&
                    <div className="jre-student-name pull-right">
                        {`${users[1].firstName} ${users[1].lastName}`}
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { users = {} } = state.auth.users;
    return {
        // role: state.auth.users[0].role,
        role: (state.auth.users.length > 0) ? state.auth.users[0].role : state.answers.users[0].role,//joyson
        users: (state.auth.users.length > 0) ? state.auth.users : state.answers.users,
        captionsFlag: state.captionsFlag,
        pauseFlag: state.pauseFlag
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCaptionsFlag: (flag, users) => {
            dispatch(setCaptionsFlag(flag, users));
        },
        setPauseFlag: (flag, users) => {
            dispatch(setPauseFlag(flag, users));
        }
    };
};


const AppPlayerContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(AppPlayerComponent);

export default AppPlayerContainer;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/page/app-player.js